import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { CLASS_START_ISO } from '../data/landing';
export function Countdown() {
  const {
    days,
    hours,
    minutes,
    seconds,
    done
  } = useCountdown(CLASS_START_ISO);
  if (done) {
    return <p className="font-serif text-4xl italic text-gold md:text-5xl" role="status" data-id="element-1" data-mp="3l2ao8q717fzz">
        La clase ya comenzó
      </p>;
  }
  const units = [{
    value: days,
    label: 'días'
  }, {
    value: hours,
    label: 'horas'
  }, {
    value: minutes,
    label: 'minutos'
  }, {
    value: seconds,
    label: 'segundos'
  }];
  return <div className="grid grid-cols-4 gap-2 sm:gap-4" role="timer" aria-live="off" data-id="element-2" data-mp="323pyp2ksgiog">
      {units.map(u => <div key={u.label} className="flex flex-col items-center rounded-xl border border-gold/40 bg-ink/40 py-5" data-id="element-3" data-mp="372jdcybtafq7">
          <span className="font-serif text-[2.6rem] font-medium leading-none tabular-nums text-gold sm:text-6xl" data-id="element-4" data-mp="10c3g9peypw3l">
            {String(u.value).padStart(2, '0')}
          </span>
          <span className="mt-3 text-[13px] uppercase tracking-[0.14em] text-ivory/70" data-id="element-5" data-mp="y16i72aoprn0">{u.label}</span>
        </div>)}
    </div>;
}